import type { BlockVariableConfig } from '../types'

import { getValuesFromBlockState } from './utils'

type BlockState = {
  companyName?: string
  bdewCode?: string
}

export const previousProviderBlockProperties = [
  'companyName',
  'bdewCode'
] as const

export type PreviousProviderBlockProperties =
  (typeof previousProviderBlockProperties)[number]

export const getVariablesFromPreviousProviderBlock =
  (): BlockVariableConfig => {
    return {
      isAccessedByIndex: false,
      properties: [...previousProviderBlockProperties]
    }
  }

export const getValuesFromPreviousProviderBlock = ({
  state: blockState
}: {
  state: unknown
}) => {
  if (!blockState) {
    return {}
  }

  // blockState is in snake_case, we need to convert it to camelCase
  const transformedBlockState = Object.entries(blockState as BlockState).reduce(
    (acc, [key, value]) => {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) =>
        letter.toUpperCase()
      )

      acc[camelKey as keyof BlockState] = value

      return acc
    },
    {} as BlockState
  )

  const data: Partial<Record<PreviousProviderBlockProperties, string>> =
    getValuesFromBlockState(
      transformedBlockState,
      previousProviderBlockProperties
    )

  return data
}
